<template>
  <KioskSplashLayout :class="$rounds.optionsWrapper">
    <div :class="$rounds.optionsButtons">
      <BaseButton
        :class="$rounds.kioskRoundButton"
        button-style="Round"
        @click="handleDineIn">
        <svg v-svg
             :class="$rounds.inIcon"
             symbol="dine-in-icon" />
        <span>Dine in</span>
      </BaseButton>
      <BaseButton
        :class="$rounds.kioskRoundButton"
        button-style="Round"
        @click="handleCarryOut">
        <svg v-svg
             :class="$rounds.outIcon"
             symbol="carry-out-kiosk" />
        <span>Carry Out</span>
      </BaseButton>
    </div>
  </KioskSplashLayout>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import KioskSplashLayout from '@/layouts/KioskSplashLayout';
import BaseButton from '@/components/BaseButton';
import { ORDER_SET_TYPE } from '@/apps/cart/store/types';
import { ORDER_TYPES } from '@/config/constants';
import { Action } from 'vuex-class';

@Component({
  components: {
    KioskSplashLayout,
    BaseButton,
  },
})

/* The page with serving options */
export default class MainOptions extends Vue {
  @Action(ORDER_SET_TYPE) setOrderType;

  /**
   * Handler for click on "Carry out" icon
   */
  handleCarryOut() {
    this.setOrderType(ORDER_TYPES.inStore);
    this.redirectToNextPage();
  }

  /**
   * Handler for click on "Curbside" icon
   */
  handleDineIn() {
    this.setOrderType(ORDER_TYPES.dineIn);
    this.redirectToNextPage();
  }

  redirectToNextPage() {
    this.$router.push({ name: 'kiosk-order-options' });
  }

  /**
   * reset selected order type and rest
   */
  mounted() {
    this.setOrderType(null);
  }
}
</script>

<style src="@/style/rounds.scss" lang="scss" module="$rounds"></style>



// WEBPACK FOOTER //
// src/apps/kiosk/components/MainOptions.vue